import { Link, Head } from '@inertiajs/react';

export default function Confidentialites({ auth, laravelVersion, phpVersion,canRegister }) {
    return (
        <>
            <Head title="Confidentialites" />
            <div className="relative sm:flex sm:justify-center sm:items-center min-h-screen bg-dots-darker bg-center bg-gray-100 dark:bg-dots-lighter dark:bg-gray-900 selection:bg-red-500 selection:text-white">
               
                <div className="max-w-7xl mx-auto p-6 lg:p-8">
                    
                    <div className="mt-16">
                        <h3 className='text-blue-50 text-3xl mb-12'>Confidentialité</h3>
                        <div className='text-white'>
                        <section className='mb-6'>
                            <h2 className='text-lg font-semibold mb-6'>1. Informations Collectées</h2>
                            <p>1.1 <strong>Données Personnelles :</strong> Nous collectons les informations que vous fournissez volontairement lors de l'inscription, telles que votre nom, adresse e-mail, et informations de profil.</p>
                        </section>

                        <section className='mb-6'>
                            <h2 className='text-lg font-semibold mb-6'>2. Utilisation des Données</h2>
                            <p>2.1 <strong>Personnalisation de l'Expérience :</strong> Nous utilisons vos données pour personnaliser votre expérience sur Klub Padel, en vous proposant des suggestions et des fonctionnalités adaptées à vos préférences.</p>
                        </section>

                        <section className='mb-6'>
                            <h2 className='text-lg font-semibold mb-6'>3. Partage des Données</h2>
                            <p>Nous ne partageons pas vos données personnelles avec des tiers sans votre consentement, sauf si cela est nécessaire pour fournir les services demandés, respecter la loi, ou protéger nos droits.</p>
                        </section>


                        </div>
                    </div>

                </div>
            </div>

            <style>{`
                .bg-dots-darker {
                    background-image: url("data:image/svg+xml,%3Csvg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.22676 0C1.91374 0 2.45351 0.539773 2.45351 1.22676C2.45351 1.91374 1.91374 2.45351 1.22676 2.45351C0.539773 2.45351 0 1.91374 0 1.22676C0 0.539773 0.539773 0 1.22676 0Z' fill='rgba(0,0,0,0.07)'/%3E%3C/svg%3E");
                }
                @media (prefers-color-scheme: dark) {
                    .dark\\:bg-dots-lighter {
                        background-image: url("data:image/svg+xml,%3Csvg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.22676 0C1.91374 0 2.45351 0.539773 2.45351 1.22676C2.45351 1.91374 1.91374 2.45351 1.22676 2.45351C0.539773 2.45351 0 1.91374 0 1.22676C0 0.539773 0.539773 0 1.22676 0Z' fill='rgba(255,255,255,0.07)'/%3E%3C/svg%3E");
                    }
                }
            `}</style>
        </>
    );
}
